var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 402,
    viewBox: "0 0 371 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_690_4562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.152 0L-0.000534058 280.857L121.787 351.171L172.46 263.403L259.451 313.628L370.931 120.538L162.152 0ZM156.411 90.304L260.8 150.573L250.665 168.127L146.276 107.858L156.411 90.304ZM192.729 228.296L105.738 178.072L115.872 160.518L202.863 210.743L192.729 228.296ZM247.794 213.279L126.007 142.965L136.141 125.411L257.929 195.725L247.794 213.279ZM305.731 153.109L166.545 72.7504L176.68 55.1969L315.865 135.556L305.731 153.109Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.184 361.216L249.316 331.181L179.723 291.001L139.184 361.216Z",
    fill: ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_690_4562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 241.077,
    height: 324.306,
    fill: "",
    transform: "translate(162.152) rotate(30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.487ef96c5c54cc28193cc4843b90eac8.svg";
export { ForwardRef as ReactComponent };